import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { axiosInstance } from "..";
import toast from "react-hot-toast";
import messages from "../../assets/Local/Local";
import axios from "axios";

const initialState = {
  agentsList: [],
  loading: "false",
  singleAgent: null,
  totalRecords: 0,
  userProfile: {},
  userImage: null,
  allocationDetails: null
};
export const addAgent = createAsyncThunk("agents/addAgent", async (data) => {
  return await axiosInstance
    .post("Auth/register", data)
    .then((response) => {
      toast.success(messages[localStorage.getItem("lang")].shared.done);
      return response;
    })
    .catch((err) => {
      toast.error(err.response.data.error.message);
      return err;
    });
});

export const uploadOneDriveFile = createAsyncThunk(
  "agents/uploadOneDriveFile",
  async (data,) => {
    return await axios({
      method: "post",
      url: `${process.env.REACT_APP_BASE_URL}OneDrive/UploadFile`,
      data,
      headers: {
        "Content-Type": "multipart/form-data",
        'Authorization': `Bearer ${localStorage.getItem("token")}`
      },
    })
      .then(function (response) {
        toast.success(messages[localStorage.getItem("lang")].shared.done);
        return response
      })
      .catch(function (error) {
        toast.error(error.response.data.error.message);
      });

  }
);

export const getAgentsList = createAsyncThunk(
  "agents/getAgentsList",
  async (params) => {
    return await axiosInstance
      .get("Agent/list", { params })
      .then((response) => {
        return response;
      })
      .catch((err) => {
        // toast.error(err.response.data.error.message, {});
        return err;
      });
  }
);

export const updateAgent = createAsyncThunk(
  `agents/updateAgent`,
  async (data, { dispatch }) => {
    return await axiosInstance
      .put(`Agent/UpdateAgent`, data)
      .then((response) => {
        toast.success(messages[localStorage.getItem("lang")].shared.done);
        return response;
      })
      .catch((error) => {
        toast.error(error.response.data.error.message);
        return error;
      });
  }
);

export const getSingleAgent = createAsyncThunk(
  `agents/getSingleAgent`,
  async (id) => {
    return await axiosInstance
      .get(`Agent/${id}`, {})
      .then((response) => {
        return response;
      })
      .catch((error) => {
        toast.error(error.response.data.error.message);
        return error;
      });
  }
);

export const getAgentProfile = createAsyncThunk(
  `agents/profile`,
  async (id) => {
    return await axiosInstance
      .get(`Agent/Profile`, {})
      .then((response) => {
        return response;
      })
      .catch((error) => {
        toast.error(error.response.data.error.message);
        return error;
      });
  }
);


export const uploadImage = createAsyncThunk(
  `agents/uploadImage`,
  async (data, { dispatch }) => {
    return await axios({
      method: "post",
      url: `${process.env.REACT_APP_BASE_URL}Media/Upload-Image`,
      data,
      headers: {
        "Content-Type": "multipart/form-data",
        'Authorization': `Bearer ${localStorage.getItem("token")}`
      },
    })
      .then((response) => {
        toast.success(messages[localStorage.getItem("lang")].shared.done);
        return response;
      })
      .catch((error) => {
        toast.error(error.response.data.error.message);
        return error;
      });
  }
);

export const getAgentAllocationDetails = createAsyncThunk(
  `agents/allocation`,
  async (id) => {
    return await axiosInstance
      .get(`Agent/Allocation/Details?userId=${id}`, {})
      .then((response) => {
        return response;
      })
      .catch((error) => {
        toast.error(error.response.data.error.message);
        return error;
      });
  }
);




const AgentsSlice = createSlice({
  name: "agents",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAgentsList.fulfilled, (state, action) => {
      state.totalRecords = action.payload.data?.totalRecords
      state.agentsList = action.payload.data?.data;
    });
    builder.addCase(getSingleAgent.fulfilled, (state, action) => {
      state.singleAgent = action.payload.data;
    });
    builder.addCase(getAgentProfile.fulfilled, (state, action) => {
      state.userProfile = action.payload.data;
      
      localStorage.setItem('userId', action.payload.data.agentId)
      localStorage.setItem('userName', action.payload.data.firstName + ' ' + action.payload.data.lastName)

    });

    builder.addCase(uploadImage.fulfilled, (state, action) => {
      state.userImage = action.payload.data.fileName;
    });
    builder.addCase(getAgentAllocationDetails.fulfilled, (state, action) => {
      state.allocationDetails = action.payload.data;
    });
    
  },
});

export const AgentsReducer = AgentsSlice.reducer;
